import api from '../../plugins/api'

export default {
  namespaced: true,
  state: {},
  actions: {
    getMissingInfo() {
      return api.MissingStudentData.getInfo()
    },
    syncMissingInfo(_, data) {
      return api.MissingStudentData.syncInfo(data)
    }
  },
  getters: {}
}
